import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { useRequestState } from "./useRequestState";
var CREATE_KEY = "postProductCampaign";
var UPDATE_KEY = "patchProductCampaign";
var LINK_KEY = "postProductCampaignProject";
export var useSaveCampaign = function () {
    var dispatch = useDispatch();
    var create = useRequestState(CREATE_KEY);
    var update = useRequestState(UPDATE_KEY);
    var link = useRequestState(LINK_KEY);
    var createCampaign = function (body) {
        dispatch(customRequestApis({
            requestKey: CREATE_KEY,
            method: "POST",
            path: "/asg/Api/V1/Campaign",
            body: { data: body },
        }));
    };
    var updateCampaign = function (_a) {
        var id = _a.id, body = _a.body;
        dispatch(customRequestApis({
            requestKey: UPDATE_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/Campaign/".concat(id),
            body: { data: body },
        }));
    };
    var linkCampaignToProject = function (body) {
        dispatch(customRequestApis({
            requestKey: LINK_KEY,
            method: "POST",
            path: "/asg/Api/V1/CampaignProject",
            body: { data: body },
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(CREATE_KEY));
            dispatch(clearCustomRequest(UPDATE_KEY));
            dispatch(clearCustomRequest(LINK_KEY));
        };
    }, []);
    return {
        createCampaign: createCampaign,
        updateCampaign: updateCampaign,
        linkCampaignToProject: linkCampaignToProject,
        createdCampaign: create.data,
        updatedCampaign: update.data,
        loadingCreate: create.loading,
        loadingUpdate: update.loading,
        errorCreate: create.error,
        errorUpdate: update.error,
        errorLink: link.error,
        clearCreated: function () { return dispatch(clearCustomRequest(CREATE_KEY)); },
        clearUpdated: function () { return dispatch(clearCustomRequest(UPDATE_KEY)); },
    };
};
